import React from 'react'
import { Header, Container } from '../../components'
import { Sidebar } from './sidebar'

const DesktopLayout = ({role, children}) => {
  return (
    <div style={{background: '#f5f5f5'}}>
      <div style={{background:'#fff'}}>
        <Header role={role} noAudienceDropdown />
      </div>
      <div className="page-header min-h-screen h-full">
        <Container className="py-10">
          <div className="flex flex-wrap -mx-4">
            <div className="w-3/12">
              <Sidebar role={role} />
            </div>
            <div className="w-9/12 -ml-4" style={{maxWidth: '900px'}}>
              <div className="rounded bg-white p-8">
                {children}
              </div>
            </div>
          </div>
        </Container>
      </div>
    </div>
  )
}

export default DesktopLayout
